// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ShieldLockComponent} from './ShieldLock.svg';

import Icon, { TIconProps } from '../Icon';

export const IconShieldLock = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ShieldLockComponent/>
  </Icon>
));
